import type React from "react";

interface MicIconProps {
  className?: string;
  style?: React.CSSProperties;
  isOn?: boolean;
}

export const MicOnIcon: React.FC<MicIconProps> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="9" y="2" width="6" height="12" rx="3" stroke="white" strokeWidth="2" />
    <path d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 18V22" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const MicOffIcon: React.FC<MicIconProps> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="9" y="2" width="6" height="12" rx="3" stroke="#F5363C" strokeWidth="2" />
    <path d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11" stroke="#F5363C" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 18V22" stroke="#F5363C" strokeWidth="2" strokeLinecap="round" />
    <path d="M3 3L21 21" stroke="#F5363C" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const MicIcon: React.FC<MicIconProps> = ({ className, style, isOn = false }) => {
  return isOn ? (
    <MicOnIcon className={className} style={style} />
  ) : (
    <MicOffIcon className={className} style={style} />
  );
};
